import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type ShoppingListProductPreparedEntityTableName =
    'shopping_list_products';

export type PreparedShoppingListProductData = {
    record: Model;
    table: ShoppingListProductPreparedEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: ShoppingListProductPreparedEntityTableName,
    operation: ValidationOperation,
): PreparedShoppingListProductData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedShoppingListProductData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
